/**
 * Le thème, côté React.
 *
 * Le document porte déjà le bon thème avant le premier rendu — le script en
 * ligne d'`index.html` s'en charge. Ce qui reste ici, c'est de suivre le
 * réglage du **système** quand il change en cours de session : quelqu'un qui
 * a choisi « Système » et dont l'ordinateur bascule au coucher du soleil doit
 * voir l'application basculer avec lui, sans recharger.
 */
import { useEffect } from "react";
import { resolveTheme } from "@/lib/theme";
import { useUiStore } from "@/stores/uiStore";

export function useSystemThemeSync(): void {
  const preference = useUiStore((s) => s.theme);
  const sync = useUiStore((s) => s.syncResolvedTheme);

  useEffect(() => {
    // Rien à écouter tant que l'utilisateur a tranché lui-même : son choix ne
    // dépend pas du système, et réappliquer à chaque bascule serait du bruit.
    if (preference !== "systeme") return;

    const mq = window.matchMedia("(prefers-color-scheme: light)");
    const suivre = () => sync(resolveTheme("systeme", mq.matches));

    suivre();
    mq.addEventListener("change", suivre);
    return () => mq.removeEventListener("change", suivre);
  }, [preference, sync]);
}
